import { Loader, CustomProvider } from 'rsuite'
import customFonts from '@/fonts'
import { Page, Spacer } from '@/components/styles'
import Footer from '@/components/footer'
import Header from '@/components/header'
import ToasterProvider from '@/components/shared/toasterProvider'

function MainPage({ children, loading }) {
  return (
    <CustomProvider>
      <ToasterProvider>
        <Page>
          <Header />
          {loading && <Loader size="lg" backdrop center />}
          {!loading && children}
          <Spacer />
          <Footer />
        </Page>
      </ToasterProvider>
    </CustomProvider>
  )
}

export default MainPage
